"use client";

// Helpers
import classnames from "classnames";
import DOMPurify from "@/app/[lang]/utils/dompurify";
import { usePathname } from "next/navigation";
import { Flex } from "@/app/[lang]/components/ui/AntdLite";

// Components
import styles from "./Features.module.scss";
import type { FeaturesProps } from "./interface";
import Feature from "./Feature";
import { useFeatureResizeCallback } from './useFeatureResizeCallback';
import {getSafeHeading} from "@/app/[lang]/utils/api-helpers";

const Features = ({ data }: FeaturesProps) => {
  const path = usePathname();
  const setRef = useFeatureResizeCallback(data.feature);
  const isHomePage = path.split("/").length === 2 || path.includes("acasa");

  if ( !!data.hidden ) {
    return null;
  }

  const TitleTag = getSafeHeading(data?.headingLevel, "h3");

  return (
    <Flex
      justify="center"
      className={ classnames( styles.wrapper, 'bg-dark-blue text-white' ) }
    >
      <div className="container">
        <section className={ styles.heading }>
          <TitleTag className={ classnames( 'h2', styles.title ) }>{ data.heading }</TitleTag>
          <div className={ styles.subtitle } dangerouslySetInnerHTML={ { __html: DOMPurify.sanitize( data.description ) } } />
        </section>

        <Flex
          className={classnames(
            styles.listFeatures,
            !isHomePage && styles.notOnHomePage,
            data.feature.length <= 2 && styles.twoFeatures
          )}
        >
          {data.feature.map((feature) => {
            return (
              <Feature
                key={feature.id}
                ref={setRef(feature.id)}
                { ...feature }
              />
          )})}
        </Flex>
      </div>
    </Flex>
  );
};

export default Features;
